import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'confirm-delete',
    templateUrl: './confirmDelete.component.html',
    styleUrls: ['./confirmDelete.component.css']
})
export class ConfirmDelete {

    constructor(public activeModal: NgbActiveModal) { }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/confirmDelete/confirmDelete.component.ts